/* eslint-disable no-underscore-dangle */
import { getOrCreateBrowserAlgoliaUserToken } from 'commons/algoliaUserToken';

const ALGOLIA_PRODUCTS_INDEX = 'products_jb4';

export const getValidQueryID = value => {
  const str = value != null ? String(value).trim() : '';
  return str.length > 0 ? str : null;
};

export const toMoneyNumber = value => {
  const n = parseFloat(value);
  return Number.isFinite(n) ? n : 0;
};

export const toQuantity = value => {
  const n = parseInt(value, 10);
  return Number.isFinite(n) && n > 0 ? n : 1;
};

export const getInsightsUserToken = () => getOrCreateBrowserAlgoliaUserToken();

export const isAlgoliaInsightsReady = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  return Boolean(window.aa && window.algoliaInitialized);
};

export const getHitProductId = hit => {
  if (!hit) {
    return '';
  }
  return String(hit.objectID ?? hit.product_id ?? '').trim();
};

export const getHitQueryID = hit =>
  getValidQueryID(hit?.__queryID ?? hit?.queryID);

export const doesHitMatchProduct = (hit, productId) => {
  const hitProductId = getHitProductId(hit);
  const productIdStr = String(productId ?? '').trim();
  return (
    hitProductId.length > 0 &&
    productIdStr.length > 0 &&
    hitProductId === productIdStr
  );
};

export const buildObjectDataEntry = ({
  price,
  discount = 0,
  quantity = 1,
  queryID = null,
}) => {
  const entry = {
    price: toMoneyNumber(price),
    discount: toMoneyNumber(discount),
    quantity: toQuantity(quantity),
  };

  const validQueryID = getValidQueryID(queryID);
  if (validQueryID) {
    entry.queryID = validQueryID;
  }

  return entry;
};

export const sumObjectDataValue = objectData =>
  objectData.reduce((total, item) => {
    const lineTotal = toMoneyNumber(item.price) * toQuantity(item.quantity);
    return total + lineTotal;
  }, 0);

export const getCartItemUnitPricing = item => {
  const quantity = toQuantity(item?.quantity);
  const lineSalePrice = toMoneyNumber(item?.price ?? item?.price_post_discount);
  const lineFullPrice = toMoneyNumber(item?.price_pre_discount);
  const lineDiscount =
    lineFullPrice > lineSalePrice
      ? lineFullPrice - lineSalePrice
      : toMoneyNumber(item?.discount_amount);

  return {
    price: lineSalePrice / quantity,
    discount: lineDiscount / quantity,
    quantity,
  };
};

export const getDisplayedInsightsPricing = priceDetails => {
  const originalPrice = toMoneyNumber(priceDetails?.priceWithOptionsPrice);
  let displayedPrice = originalPrice;

  if (priceDetails?.hasTieredDiscount) {
    displayedPrice = toMoneyNumber(priceDetails.maxTieredDiscountedPrice);
  } else if (priceDetails?.hasDiscount) {
    displayedPrice = toMoneyNumber(priceDetails.salePriceWithOptionsPrice);
  }

  const price = displayedPrice || originalPrice;
  return {
    price,
    discount: Math.max(0, originalPrice - price),
  };
};

export { ALGOLIA_PRODUCTS_INDEX };
